<template>
  <v-btn 
      @click="toggleMobileMenu"
      class="trigger-menu"
      rounded="0"
      variant="text"
      aria-label="Menu"
      aria-haspopup="true" aria-expanded="false" aria-controls="menuList"
      title="Menu">
        <v-icon v-if="!showMobileMenu" size="35">mdi-information-variant</v-icon>
        <v-icon v-else size="35">mdi-close</v-icon>
    </v-btn>
</template>

<script lang="ts">
import { computed, defineComponent, ref, Ref } from 'vue';
import store                              from '@/store';

const TriggerMobileMenu: object = defineComponent({
  props: {
  },
  setup() {
    const showMobileMenu: Ref<boolean> = computed((): boolean => store.state.showMobileMenu);

    const toggleMobileMenu = () => {
      store.commit('toggleMobileMenu');
    };
    
    return {
      showMobileMenu,
      toggleMobileMenu,
    };
  },
});
export default TriggerMobileMenu;
</script>

<style scoped lang="scss">
.trigger-menu {
  position: fixed;
  top: 0;
  right: 0;
  z-index: 1002;
  background-color: $main-bg-color;
  color: $main-font-color;
  border: 2px solid $nav-layers-box-border;
}
</style>
